import Vue from 'vue'
// 全局引入常用的Vant组件，其他组件没列举到的可以在页面内单独引入
import { Toast, Field, Cell, CellGroup, Button, Form, Col, Row, Popup, Picker, PullRefresh, Loading, List, Icon, Empty, Uploader, ActionSheet, Notify, ImagePreview, Rate, Dialog, Calendar, Cascader, SwipeCell } from 'vant'
// 自定义loading

// import Vconsole from 'vconsole';
// new Vconsole();
Toast.setDefaultOptions('text', {
  position: 'top',
  className: 'toast-class-name'
})
Vue.use(Toast)
Vue.use(Field)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Button)
Vue.use(Form)
Vue.use(Col)
Vue.use(Row)
Vue.use(Popup)
Vue.use(Picker)
Vue.use(PullRefresh)
Vue.use(Loading)
Vue.use(List)
Vue.use(Icon)
Vue.use(Empty)
Vue.use(Uploader)
Vue.use(ActionSheet)
Vue.use(Notify)
Vue.use(Rate)
Vue.use(Dialog)
Vue.use(Calendar)
Vue.use(Cascader)
Vue.use(SwipeCell)

const Components = {
  install (Vue) {
    Vue.prototype.$imagePreview = ImagePreview
  }
}

export default Components